export default __webpack_public_path__ + "assets/ico-parkdetail.263bc595.svg";